import Clazz from '../common/Clazz';

/**
 * 地图组件基类
 * 一个地图中只能有一个同类型的组件
 */
export default class Component extends Clazz {
    /**
     * 构造方法.
     * @returns {undefined}
     */
    constructor(options) {
        super(options);
    }

    /**
     * 添加到地图
     * @param {Object}      map map对象
     * @returns {undefined}
     */
    addTo(map) {
        if (map) {
            map.addComponent(this);
            return this;
        }
        return null;
    }

    /**
     * 删除
     */
    remove() {
        return this.removeFrom(this._map);
    }

    /**
     * 从地图中删除
     * @param {object} map 地图实例 
     */
    removeFrom(map) {
        if (map) {
            map.removeComponent(this);
            return this;
        }
        return null;
    }

    /**
     * 添加到地图对象时调用
     * @param {object} map 地图对象
     */
    onAdd(map) {
        this._map = map;
    }

    /**
     * 从地图对象删除时调用
     */
    onRemove() {
        this._map = null;
    }

    get map() {
        return this._map;
    }

    /**
     * 组件是否可用
     * 只有绑定到具体的map对象上，才可用
     */
    isValid() {
        return !!this._map;
    }
}
